import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { movieCategories } from "@/mocks/movies";

export default function Navbar() {
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  const isActive = (path: string) => {
    if (path === "/") return location.pathname === "/";
    return location.pathname.startsWith(path);
  };

  return (
    <header className="sticky top-0 z-50 bg-background-50/95 backdrop-blur-md border-b border-background-200/60">
      <nav className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 max-w-[1400px] mx-auto">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <span className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
              <i className="ri-movie-line text-background-50 text-lg"></i>
            </span>
            <span className="text-xl font-bold text-foreground-950">蓝莓影院</span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
                isActive("/") && !isActive("/category") ? "bg-primary-500 text-background-50" : "text-foreground-700 hover:bg-background-100"
              }`}
            >
              首页
            </Link>
            {movieCategories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
                  isActive(`/category/${cat.slug}`) ? "bg-primary-500 text-background-50" : "text-foreground-700 hover:bg-background-100"
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
                isActive("/about") ? "bg-primary-500 text-background-50" : "text-foreground-700 hover:bg-background-100"
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 cursor-pointer"
            aria-label="菜单"
          >
            <i className={mobileOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden border-t border-background-200/60 py-3 flex flex-col gap-1 pb-4">
            <Link
              to="/"
              onClick={() => setMobileOpen(false)}
              className={`px-4 py-3 rounded-lg text-sm font-medium whitespace-nowrap cursor-pointer ${
                isActive("/") && !isActive("/category") ? "bg-primary-500 text-background-50" : "text-foreground-700 hover:bg-background-100"
              }`}
            >
              首页
            </Link>
            {movieCategories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                onClick={() => setMobileOpen(false)}
                className={`px-4 py-3 rounded-lg text-sm font-medium whitespace-nowrap cursor-pointer ${
                  isActive(`/category/${cat.slug}`) ? "bg-primary-500 text-background-50" : "text-foreground-700 hover:bg-background-100"
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              onClick={() => setMobileOpen(false)}
              className={`px-4 py-3 rounded-lg text-sm font-medium whitespace-nowrap cursor-pointer ${
                isActive("/about") ? "bg-primary-500 text-background-50" : "text-foreground-700 hover:bg-background-100"
              }`}
            >
              关于我们
            </Link>
          </div>
        )}
      </nav>
    </header>
  );
}